import { AppTracker } from 'shared/analytics/tracker';
import { ANALYTIC_V3_EVENTS } from 'views/main/organization/analytics-v3/constants';
import { useGetAnalyticsCountVsTime } from 'views/main/organization/analytics-v3/hooks/useGetAnalyticsData';
import Empty from 'views/main/organization/analytics-v3/icons/empty';
import { BasicBar } from '../../../Charts/Bar';
import { BarChartLoading } from '../../../Charts/Bar/Loading';
import Error from 'views/main/organization/analytics-v3/components/Error';
import { AxiosError } from 'axios';
export const IncidentCountVsTime = ({ isOrgAnalytics = false }: { isOrgAnalytics?: boolean }) => {
  const {
    data,
    isLoading,
    isError,
    refetch: refetchCountVsTime,
    error,
  } = useGetAnalyticsCountVsTime({
    isOrgAnalytics,
  });
  if (isError)
    return (
      <Error
        onRefreshClick={refetchCountVsTime}
        errorMessage={(error as AxiosError).response?.data?.message}
      />
    );
  if (isLoading) return <BarChartLoading />;
  if (!data) return null;
  const isEmpty = data?.length === 0;
  if (isEmpty) return <Empty />;
  const handleLegendSelect = (name: string) => {
    AppTracker.track(
      ANALYTIC_V3_EVENTS.INCIDENT_ANALYTICS_CHART_LEVEL_FILTER_APPLIED,
      {
        'Analytics Scope': isOrgAnalytics ? 'Organization Analytics' : 'Team Analytics',
        'Analytics Type': 'Incident Analytics',
        'Analytics Tab': 'Incident Analytics',
        'Chart Title': 'Incident Count Over Time',
        'Legend Name': name,
      },
      true,
    );
  };
  return <BasicBar data={data} onLegendSelect={handleLegendSelect} />;
};
